export const getModal = (state) => state.modal;
export const getTitle = (state) => state.modal.title;
export const getIsOpen = (state) => state.modal.isOpen;
